import type { ReactNode } from 'react';
import { useLocaleStore } from '@/entities/locale';
import { env } from '@/shared/config';
import { IntlProviderWrapper } from '@/shared/i18n';
import { getMessagesForLocale } from './messages';

interface LandingIntlProviderProps {
  children: ReactNode;
}

export function LandingIntlProvider({ children }: LandingIntlProviderProps) {
  const locale = useLocaleStore((state) => state.locale);
  const messages = getMessagesForLocale(locale, env.VITE_REGION);

  return (
    <IntlProviderWrapper locale={locale} messages={messages ?? {}}>
      {children}
    </IntlProviderWrapper>
  );
}
